import Vue from 'vue'

export const orderService = {
  create,
  get,
  fetch,
  fetchAll,
  fetchUsers,
  fetchProducts,
  fetchCouponCodeInfo,
  changeStatus,
  changeDelivered,
  sendDeliveredMail,
  saveComment,
  captureOrder
}

function create (items, paymentMethod, comments, couponCode, termsReview, pickupPoint, expectedDeliveryDate, shippingAddress, phoneNumber, billingAddress, shippingPrice, discountPrice) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-create'), {
      'items': items,
      'paymentMethod': paymentMethod,
      'comments': comments,
      'couponCode': couponCode,
      'review': termsReview,
      'pickupPoint': pickupPoint,
      'expectedDeliveryDate': expectedDeliveryDate,
      'shippingAddress': shippingAddress,
      'phoneNumber': phoneNumber,
      'billingAddress': billingAddress,
      'shipping': shippingPrice,
      'discount': discountPrice
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function get (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order/' + id))
      .then(response => {
        let order = response.data.data
        order.products.forEach(function (product) {
          processProduct(product)
        })
        resolve(order)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetch (page, size) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order'), {
      page: page,
      size: size
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchAll (page, size, pickupPointId, userId, productId, delivered, deliverable, shipping, paid) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order'), {
      page: page,
      size: size,
      pickupPointId: pickupPointId,
      userId: userId,
      productId: productId,
      delivered: delivered,
      deliverable: deliverable,
      shipping: shipping,
      paid: paid,
      admin: true
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchUsers () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-user'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchProducts () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-product'))
      .then(response => {
        let products = response.data.data
        products.forEach(function (product) {
          processProductForOrders(product)
        })
        resolve(products)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchCouponCodeInfo (code) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-coupon-code'), {
      code: code
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function changeStatus (id, status) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-status'), {
      id: id,
      status: status
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function changeDelivered (id, delivered) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-delivered'), {
      id: id,
      delivered: delivered
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function sendDeliveredMail (orderId, productPickupPersonId) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-delivered-mail'), {
      orderId: orderId,
      productPickupPersonId: productPickupPersonId
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function saveComment (orderId, comment) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-comment'), {
      orderId: orderId,
      comment: comment
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function captureOrder (orderId, paypalOrderId) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/product-order-webhook/' + orderId), {
      id: paypalOrderId,
      payment_method: 'paypal'
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function processProductForOrders (product) {
  if (product.language && product.language.length > 0) {
    if (!(product.language.length === 1 && product.language[0] === 'en')) {
      product.name = product.name + ' (' + product.language.join('/').toUpperCase() + ')'
    }
  }
}

function processProduct (product) {
  product.image = Vue.prototype.$hostname.concat('/image/product/').concat(product.id).concat('/').concat(product.image)
  product.price = parseFloat(Vue.options.filters.round(product.price, 2))
}



// WEBPACK FOOTER //
// ./src/services/order.service.js